module.exports = __webpack_public_path__ + "static/media/logowithtext.5e97d075.png";